<template>
    <div v-if="procedimento" class="mb-5">

        <template v-if="procedimento.outros_procedimentos">
            <div v-for="(proced, ipx) in procedimento.outros_procedimentos" :key="ipx">
                <az-input
                    sizing="sm"
                    :edicao="false"
                    v-model="proced.search">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(procedimento.outros_procedimentos, ipx)">
                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:buttonposb v-if="proced.js_complementos && proced.js_complementos.length">
                        <div class="input-group-append">
                            <select class="form form-control" v-model="proced.st_regiao">
                                <option>Região...</option>
                                <option v-for="(comp, icx) in proced.js_complementos" :key="icx" :value="comp">{{ comp }}</option>
                            </select>
                        </div>
                    </template>
                </az-input>
            </div>     
        </template>

        <az-input
            placeholder="Adicionar procedimento..."
            sizing="sm"
            icon="fas fa-plus fa-fw"
            type="autocomplete" 
            optionsMode="aql"
            service="procedimentos.index"
            :optionsParm="{
                agenda: true, 
                agenda_add: true, 
                ativos: true, 
                id_medico: procedimento.medico ? procedimento.medico.id_pessoa : null, 
                id_operadora: procedimento.plano ? procedimento.plano.id_operadora : null, 
                id_plano: procedimento.plano ? procedimento.plano.id_plano : null, 


            }"
            v-model="novoProcedimento"
            :procsigla="true"
            ref="info_procedimento"
            @selecionado="incluirProcedimento()" />

        <template v-if="procedimento.outros_procedimentos && procedimento.outros_procedimentos.length > 0 && slots">
            <div class="btn-group dropup">
                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    :class="procedimento.slots > 1 ? 'btn-primary' : 'btn-secondary'">
                    Ocupar {{ procedimento.slots ? procedimento.slots : 1 }} 
                    {{ procedimento.slots > 1 ? 'horários' : 'horário' }} da agenda
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="#" @click="procedimento.slots = 1" :class="( procedimento.slots ? procedimento.slots : 1 ) == 1 ? 'active' : ''">
                        Ocupar 1 horário da agenda
                    </a>
                    <a class="dropdown-item" href="#" v-for="idx in procedimento.outros_procedimentos.length" :key="idx"
                        @click="procedimento.slots = idx + 1" :class="procedimento.slots == idx + 1 ? 'active' : ''">
                        Ocupar {{ idx + 1 }} horários da agenda
                    </a>
                </div>
            </div>
        </template>

        <br><br><br><br><br>

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            novoProcedimento: null, 
            procedimento: null, 
        }
    },

    props: ['value', 'slots'], 

    components: { 
        AzInput,
    },

    watch: { 
        procedimento: {
            handler: function (newValue) { 
                if ( newValue )
                    this.$emit('input', newValue);
            },
            immediate: true,
            deep: true, 
        },

        value: {
            handler: function (newValue) {
                this.procedimento = newValue;
            },
            immediate: true,
        },
    },

    methods: { 
        incluirProcedimento() { 
            if ( this.novoProcedimento && Array.isArray(this.novoProcedimento) ) {
                let lista = _.cloneDeep(this.novoProcedimento);

                lista.forEach(proc => { 
                    this.novoProcedimento = proc;
                    this.incluirProcedimento();
                });
                return;
            }

            if ( this.novoProcedimento && this.procedimento ) { 
                if ( !this.procedimento.outros_procedimentos )
                    this.procedimento.outros_procedimentos = [];

                this.procedimento.outros_procedimentos.push({ 
                    in_quantidade: 1, 
                    id_procedimento: this.novoProcedimento.id_procedimento,
                    search: this.novoProcedimento.search 
                });
            }

            this.$nextTick(() => {
                this.novoProcedimento = "";
            });
        },

        removerElemento (lista, index) { 
            lista.splice(index, 1);
            this.$forceUpdate();
        },
    }
}
</script>